export type FeatureModule =
  | 'trading'
  | 'sentinel'
  | 'productivity'
  | 'finance'
  | 'documentation'

export const FEATURE_MODULE_ORDER: FeatureModule[] = [
  'trading',
  'sentinel',
  'productivity',
  'finance',
  'documentation',
]

export const FEATURE_MODULE_ROUTES: Record<FeatureModule, string> = {
  trading: '/calculators/module-a',
  sentinel: '/',
  productivity: '/todos',
  finance: '/finance/budget-tracker',
  documentation: '/documentation',
}

export function isFeatureModule(value: unknown): value is FeatureModule {
  return typeof value === 'string' && FEATURE_MODULE_ORDER.includes(value as FeatureModule)
}

export function getDefaultModuleRoute(modules: FeatureModule[], isAdmin = false): string {
  if (isAdmin) return '/'
  const firstModule = FEATURE_MODULE_ORDER.find((module) => modules.includes(module))
  return firstModule ? FEATURE_MODULE_ROUTES[firstModule] : '/access-pending'
}
